exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".textjustify[data-v-5c3d7123]{text-align:justify}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelDescriptionNavigation.vue"],"names":[],"mappings":"AACA,8BACA,kBAAmB,CAClB","file":"ValuationModelDescriptionNavigation.vue","sourcesContent":["\n.textjustify[data-v-5c3d7123] {\ntext-align:justify;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c3d7123","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelDescriptionNavigation.vue
// module id = 2778
// module chunks = 29